/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { AutoFocus } from 'primeng/autofocus';

// PrimeNG bug workaround: AutoFocus directive sets the native `autofocus` HTML
// attribute when its input is `undefined` (only skips when strictly `=== false`).
// This causes "Autofocus processing was blocked" browser warnings when multiple
// p-button components are rendered (e.g. inside aiops-reaction). Patch the
// prototype so any falsy value is treated as disabled autofocus.
const _originalOnContentChecked = (AutoFocus.prototype as any).onAfterContentChecked;
(AutoFocus.prototype as any).onAfterContentChecked = function () {
  if (!this.autofocus) {
    this.autofocus = false;
  }
  if (_originalOnContentChecked) {
    _originalOnContentChecked.call(this);
  }
};

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
